import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageCessy: React.FC = () => (
  <LocalSeoPage
    city="Cessy"
    slug="depannage-informatique-cessy"
    metaTitle="Dépannage Informatique Cessy | Technicien PC Pays de Gex"
    metaDescription="Technicien informatique à Cessy. PC lent, virus, WiFi, Windows bloqué. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous lâche à Cessy ? Notre technicien intervient rapidement à domicile ou à distance. PC lent, virus, panne WiFi ou Windows bloqué — on règle ça simplement, avec un diagnostic 100 % gratuit et sans engagement."
    postalCode="01170"
    nearbyTowns={[
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Ornex', link: '/depannage-informatique-ornex' },
      { name: 'Segny', link: '/depannage-informatique-segny' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Ornex', href: '/depannage-informatique-ornex' },
      { label: 'Dépannage informatique à Segny', href: '/depannage-informatique-segny' },
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageCessy;
